import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  Inject,
  Renderer2,
  NgZone,
} from '@angular/core';
import {} from 'googlemaps';
import { finalize, Subject, firstValueFrom } from 'rxjs';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  NgControl,
} from '@angular/forms';
import {
  MapaServiceService,
  ServiceFilterStartEndData,
} from 'src/app/services/mapa/mapa-service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TuiAlertService, TuiHostedDropdownComponent } from '@taiga-ui/core';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
// import { MarkerClusterer } from "@googlemaps/markerclusterer";
declare var MarkerClusterer: any;
declare var OverlappingMarkerSpiderfier: any;
declare var moment: any;
import { TranslateService } from '@ngx-translate/core';
import { TuiInputDateRangeModule } from '@taiga-ui/kit';
import { DriverService } from 'src/app/services/driver/driver.service';
import { MapaDataUnifierService } from 'src/app/services/mapa/mapa-data-unifier.service';
import {
  DriverData,
  DriverDetails,
  DriverDetailsResponse,
} from 'src/app/models/driver/driver.model';
import { OrderData } from 'src/app/models/service/service.model';

@Component({
  selector: 'app-mapa-pool-manager',
  templateUrl: './mapa-pool-manager.component.html',
  styleUrls: ['./mapa-pool-manager.component.css'],
})
// Deprecated: kept temporarily as a rollback fallback while unified map is validated in production.
export class MapaPoolManagerComponent {
  @ViewChild('gmapContainer', { static: false }) gmap: ElementRef | undefined;
  map: any = google.maps.Map;
  lat = 40.4165;
  lng = -3.70256;
  zoom_level = 6;
  coordinates = new google.maps.LatLng(this.lat, this.lng);
  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 6,
    disableDefaultUI: true,
  };
  open = false;
  selectedItemFilter = 'services';
  // count_unsigned_services = 0;
  // count_drivers: any = 0;
  date: any = Math.floor(new Date('2024-08-09').getTime() / 1000);
  show_loader = false;

  moment = moment;

  active_inside_service_div = 'closets';

  directionsRenderers: google.maps.DirectionsRenderer[] = [];
  type_driver_start: any = 'service';
  icon_driver_start: any = '';

  modalRef?: BsModalRef;

  filterForm = this.fb.group({
    zoneFilter: '',
    mapfilter: '',
    dateFilter: [['', '']],
  });

  filterDriverServiceForm = this.fb.group({
    driverservicefilter: '',
  });

  //data-dummy para lista de servicios
  elements_services: OrderData[] = [];
  filtered_services: OrderData[] = [];
  //

  //data-dummy para lista de conductores
  elements_drivers: DriverDetails[] = [];
  filtered_drivers: DriverDetails[] = [];

  showDriverServicesId: string = '';
  driverServices: OrderData[] = [];

  leftDivStyles = {
    x: 440,
  };
  expandDivLeft = true;
  show_left_div = true;
  zones: any;
  service_data: any;
  count_drivers_closets = 0;

  active_detail_service: OrderData | null = null;
  formatedHourToShow: any;
  active_driver: any;

  drivers_for_service: any = [];
  selectedZone: any = '#';

  PointsMarkers: any = [];
  dateFilter: any;
  show_assign_services: string = '';
  active_desasign_driver: DriverDetails | undefined;

  VehicleChassisType = [
    {
      value: 1,
      name: 'SEDAN',
      real_name: 'Turismo',
    },
    {
      value: 2,
      name: 'MINIVAN',
      real_name: 'Monovolumen',
    },
    {
      value: 3,
      name: 'ATV',
      real_name: 'Todoterreno',
    },
    {
      value: 4,
      name: 'LIGHT_VAN',
      real_name: 'Furgoneta ligera',
    },
    {
      value: 5,
      name: 'VAN',
      real_name: 'Furgoneta',
    },
    {
      value: 6,
      name: 'BOX_TRUCK',
      real_name: 'Furgón',
    },
    {
      value: 20,
      name: 'SCOOTER',
      real_name: 'Moto (hasta 125cc)',
    },
    {
      value: 21,
      name: 'MOTORBIKE',
      real_name: 'Moto +125cc',
    },
  ];

  markerCluster: any;
  directionsRenderer: any;
  provider_address: any = '';

  rolesGeneral: any[] = [
    { name: this.translate.instant('personal.role_not_specified'), role: 'NOT_SPECIFIED' },
    { name: this.translate.instant('personal.role_regular'), role: 'REGULAR' },
    { name: this.translate.instant('personal.role_long_distance'), role: 'LONG_DISTANCE' },
    { name: this.translate.instant('personal.role_broom_car'), role: 'BROOM_CAR' },
    { name: this.translate.instant('personal.role_mobile_washer'), role: 'MOBILE_WASHER' },
    { name: this.translate.instant('personal.role_implant_washer'), role: 'IMPLANT_WASHER' },
    { name: this.translate.instant('personal.role_implant_office'), role: 'IMPLANT_OFFICE' },
    { name: this.translate.instant('personal.role_mobile_workshop'), role: 'MOBILE_WORKSHOP'},
    { name: this.translate.instant('personal.role_dispatch_vehicle'), role: 'DISPATCH_CAR'},
  ];

  markers: google.maps.Marker[] = [];
  isInfoWindowOpen = false;
  currentCluster: any = null;
  hoverTimeout: any = null;
  isMouseOverCluster: any = false;
  customMarkers: google.maps.Marker[] = [];

  constructor(
    @Inject(TuiAlertService) private readonly alerts: TuiAlertService,
    private fb: FormBuilder,
    private ms: MapaServiceService,
    private modalService: BsModalService,
    private renderer: Renderer2,
    public hs: HistoryServicesService,
    private ngZone: NgZone,
    private translate: TranslateService,
    private DriverService: DriverService,
    private mapaDataUnifier: MapaDataUnifierService
  ) {}

  ngOnInit() {
    let divmap = document.getElementsByClassName('custom-container');
    if (divmap.length > 0) {
      let mapdiv = divmap[0] as HTMLElement;
      mapdiv.style.padding = '0px';
    }

    this.ms.getZones().subscribe((zones: any) => {
      this.zones = zones.zones;
    });
  }

  showDriverServices(driverId: string, eventClick?: Event) {
    // if (eventClick) {
    //   eventClick.stopPropagation();
    // }
    if (this.showDriverServicesId == driverId) {
      this.cleanDriverServices();
      return;
    }
    this.showDriverServicesId = driverId;
    this.driverServices = this.getAllServicesByDriverId(driverId);
  }

  cleanDriverServices() {
    this.showDriverServicesId = '';
    this.driverServices = [];
  }

  ngAfterViewInit() {
    this.mapInitializer();
    this.filterForm.get('zoneFilter')?.valueChanges.subscribe((value) => {
      this.loadData();
    });

    this.filterForm.get('dateFilter')?.valueChanges.subscribe((value) => {
      this.loadData();
    });
  }

  ngOnDestroy() {
    let divmap = document.getElementsByClassName('custom-container');
    if (divmap.length > 0) {
      let mapdiv = divmap[0] as HTMLElement;
      mapdiv.style.padding = '30px';
    }
  }

  mapInitializer() {
    this.map = new google.maps.Map(this.gmap?.nativeElement, this.mapOptions);
  }

  getTypeChassisByType(vehicleName: any) {
    const selectedVehicle = this.VehicleChassisType.find(
      (type: any) => type.name === vehicleName
    );
    return selectedVehicle?.real_name;
  }

  changeInsideServiceactive(type: any) {
    this.active_inside_service_div = type;
  }

  div_loder = document.getElementById('loader');
  showLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'flex');
    }
  }

  hideLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'none');
    }

    setTimeout(() => {
      const closeDiv = document.querySelector('.t-close');
      if (closeDiv) {
        (closeDiv as HTMLElement).click();
      }
    }, 5000);
  }

  getRandomOffset() {
    return (Math.random() - 0.9) / 10; // Ajusta este valor según sea necesario
  }

  getRoleInfo(roleName: string) {
    const selecteRole = this.rolesGeneral.find(
      (rol: any) => rol.role === roleName
    );
    return selecteRole?.name;
  }

  selectedDate: any;

  onDateChange() {
    this.filterForm.patchValue({
      dateFilter: this.selectedDate,
    });
  }

  resetDate() {
    this.selectedDate = null;
  }

  getServiceByDriverId(driverId: string): OrderData | undefined {
    let service = this.elements_services.find(
      (service: OrderData) => service.driverGuid === driverId
    );

    return service;
  }

  getAllServicesByDriverId(driverId: string): OrderData[] {
    let services = this.elements_services.filter(
      (service: OrderData) => service.driverGuid === driverId
    );
    return services;
  }

  async focusDriverMap(driver: DriverDetails, clearMarkers?: boolean) {
    if (driver.serviceAssigned) {
      this.showDriverServices(driver.driverId);
    }

    if (driver.lastLocation) {
      // let service = this.getServiceByDriverId(driver.driverId);
      // if (service) {
      //   this.setActiveService(service, driver.driverId);
      // }

      setTimeout(() => {
        this.centerMapOnLocation(
          driver.lastLocation.Latitude,
          driver.lastLocation.Longitude,
          driver.fullName,
          driver,
          clearMarkers
        );
      }, 200);
    } else {
      this.alerts
        .open('El conductor no tiene una ubicación válida', {
          label: 'Sin ubicación',
          status: 'error',
          autoClose: 3000,
        })
        .subscribe();
    }
  }

  centerMapOnLocation(
    latitude: number,
    longitude: number,
    title?: string,
    driver?: any,
    clearMarkers?: boolean
  ): void {
    // Limpiar marcadores anteriores
    if (clearMarkers) {
      this.clearMarkers();
    }

    const newCoordinates = new google.maps.LatLng(latitude, longitude);
    this.map.setCenter(newCoordinates);
    this.map.setZoom(15);
    let data = {
      type: 'driver',
      obj: driver.lastLocation,
      gi: driver,
    };
    this.PointsMarkers.push(data);
    this.drawMapPoints();
  }

  getElements_driversById(id: any) {
    return this.elements_drivers.find((x: any) => x.driverId == id);
  }

  async LoadExternalDrivers() {
    try {
      const res =
        await this.DriverService.getActiveExternalDrivers().toPromise();

      const activeDrivers = res?.activeDrivers;
      if (activeDrivers) {
        const drivers = await Promise.all(
          activeDrivers.map(async (element: any) => {
            const driverObj: any = await this.ms
              .getDriver(element.driverGuid)
              .toPromise();

            if (!driverObj.drivers) return;

            let driver = driverObj.drivers[0];
            if (driver && driver.lastLocation) {
              const data = {
                type: 'driver',
                obj: driver?.lastLocation,
                gi: driver,
              };
              this.PointsMarkers.push(data);
            }

            driver.serviceAssigned = this.getServiceByDriverId(driver.driverId)
              ? true
              : false;

            return driver;
          })
        );
        return drivers;
      }
      return [];
    } catch (error) {
      console.error('Error al cargar los drivers:', error);
      return [];
    }
  }

  limpiarDriverId(valor: string): string {
    return this.mapaDataUnifier.sanitizeDriverId(valor);
  }

  async loadData() {
    this.resetFilteredData();

    if (
      this.filterForm.value.dateFilter &&
      this.filterForm.value.dateFilter[0] &&
      this.filterForm.value.zoneFilter
    ) {
      this.showLoader();
      const serviceData: ServiceFilterStartEndData = {
        StartDate: this.filterForm.value.dateFilter[0],
        EndDate: this.filterForm.value.dateFilter[1],
        ZoneGuid: this.filterForm.value.zoneFilter,
      };

      this.elements_services = [];
      this.filtered_services = [];
      this.elements_drivers = [];
      this.filtered_drivers = [];

      this.clearMarkers();
      this.PointsMarkers = [];

      try {
        this.elements_services =
          (
            (await firstValueFrom(
              this.ms.getAssignedServices(serviceData)
            )) as any
          )?.mapData ?? [];
      } catch (error) {
        console.error('Error al obtener servicios asignados:', error);
      }

      try {
        let unassignedServices =
          (
            (await firstValueFrom(
              this.ms.getUnassignedServices(serviceData)
            )) as any
          )?.mapData ?? [];
        this.elements_services = [
          ...unassignedServices,
          ...this.elements_services,
        ];
      } catch (error) {
        console.error('Error al obtener servicios no asignados:', error);
      }

      this.elements_services = this.mapaDataUnifier.normalizePoolServices(
        this.elements_services,
        this.translate.currentLang
      );

      try {
        this.elements_drivers = await this.LoadExternalDrivers();
      } catch (error) {
        console.error('Error al cargar conductores:', error);
      }

      if (this.directionsRenderer) {
        this.directionsRenderer.setDirections({ routes: [] });
        this.directionsRenderer.setMap(null);
      }

      this.directionsRenderers.forEach((renderer) => {
        renderer.setMap(null);
      });
      this.directionsRenderers = [];

      this.customMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.customMarkers = [];

      this.PointsMarkers = this.mapaDataUnifier.buildPoolMapPoints(
        this.elements_services
      );
      this.filtered_services = [...this.elements_services];

      this.resetFilteredData();
      this.drawMapPoints();
      this.hideLoader();
    }
  }

  filterData(event: Event | string): void {
    const query =
      typeof event == 'string'
        ? event.toLowerCase()
        : (event.target as HTMLInputElement).value.toLowerCase();
    if (this.selectedItemFilter == 'services') {
      this.filtered_services = [...this.elements_services].filter(
        (item: any) =>
          item?.licensePlate?.toLowerCase().includes(query) ||
          item?.productName?.toLowerCase().includes(query) ||
          item?.startUbication?.address.toLowerCase().includes(query)
      );
    }

    if (this.selectedItemFilter == 'drivers') {
      this.filtered_drivers = [...this.elements_drivers].filter(
        (item: any) =>
          (item?.fullName.toLowerCase().includes(query) ||
            item?.contactPhoneNumber.toLowerCase().includes(query)) &&
          item?.isActive === true
      );
    }
  }

  resetFilteredData(): void {
    this.filterForm.get('mapfilter')?.setValue('');

    this.filtered_services = [...this.elements_services];
    this.filtered_drivers = [...this.elements_drivers].filter(
      (item: any) => item?.fullName && item?.isActive === true
    );
  }

  filterDataDriverService(event: Event): void {
    const query = (event.target as HTMLInputElement).value.toLowerCase();
    this.filtered_drivers = [...this.elements_drivers].filter(
      (item: any) =>
        item?.fullName.toLowerCase().includes(query) && item.isActive
    );
  }

  getInitial(nombre: string): string {
    if (!nombre) return '';

    const partes = nombre
      .trim()
      .split(/\s+/)
      .filter((p) => p);

    const primeraLetra = partes[0]?.[0]?.toUpperCase() ?? '';
    const segundaLetra = partes[1]?.[0]?.toUpperCase() ?? '';

    return `
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#59F89C"/>
      <text
        x="50%" y="53%"
        dominant-baseline="middle"
        text-anchor="middle"
        fill="white"
        font-size="17"
        font-family="Arial"
      >
        ${primeraLetra + segundaLetra}
      </text>
    </svg>`;
  }

  async drawRoutes(service: OrderData): Promise<void> {
    this.ngZone.run(() => {
      if (this.directionsRenderer) {
        this.directionsRenderer.setDirections({ routes: [] });
        this.directionsRenderer.setMap(null);
      }

      this.directionsRenderers.forEach((renderer) => {
        renderer.setMap(null);
      });
      this.directionsRenderers = [];

      this.customMarkers.forEach((marker) => {
        marker.setMap(null);
      });

      this.customMarkers = [];
      this.clearMarkers();
    });

    const directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });
    let waypts: google.maps.DirectionsWaypoint[] = [];
    let start = {
      lat: service.startUbication.latitude,
      lng: service.startUbication.longitude,
    };
    let end = {
      lat: service.endUbication.latitude,
      lng: service.endUbication.longitude,
    };

    this.directionsRenderer.setMap(this.map);
    if (waypts.length > 0) {
      directionsService.route(
        {
          origin: start,
          destination: end,
          waypoints: waypts,
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response) => {
          this.directionsRenderer.setDirections(response);
          this.directionsRenderers.push(this.directionsRenderer);
          this.addCustomMarkers(response);
        }
      );
    } else {
      directionsService.route(
        {
          origin: start,
          destination: end,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response) => {
          this.directionsRenderer.setDirections(response);
          this.directionsRenderers.push(this.directionsRenderer);
          this.addCustomMarkers(response);
        }
      );
    }
  }

  mt: any;
  drivers_markers: any = [];

  drawMapPoints() {
    this.PointsMarkers.forEach((obj: any, index: any) => {
      const offset = 0.00005;
      var latOffset = this.getRandomOffset();
      var lngOffset = this.getRandomOffset();
      var latOffset2 = this.getRandomOffset();
      var lngOffset2 = this.getRandomOffset();

      if (obj.type == 'pickup') {
        if (obj.gi) {
          var dataService = JSON.stringify(obj.gi);
        } else {
          var dataService = '{}';
        }

        // let textDateStart = obj.gi.pickupDate.time.split(':');
        // let dateFormated = textDateStart[0] + ':' + textDateStart[1];

        let mrkc = new google.maps.LatLng(obj.obj.latitude, obj.obj.longitude);
        let mrk = new google.maps.Marker({
          position: mrkc,
          // map: this.map,
          title: `
                          <span style="cursor:pointer" class="span_service_map"
                                data-service='${dataService.replace(
                                  /'/g,
                                  '&apos;'
                                )}'>
                            <img src="/assets/img/icon_service.png"/>
                            ${obj.obj.address},
                            <b>${this.hs.translate(obj.gi.productName)} - ${
            obj.gi.licensePlate
          } </b>
                          </span>
                        `,
          icon: '/assets/img/icon_service.png',
        });
        obj.marker = mrk;
        // mrk.setMap(this.map);
      }

      if (obj.type == 'dest') {
        if (obj.gi) {
          var dataService = JSON.stringify(obj.gi);
        } else {
          var dataService = '{}'; // Un valor JSON válido por defecto
        }

        // let textDateStart = obj.gi.pickupDate.time.split(':');
        // let dateFormated = textDateStart[0] + ':' + textDateStart[1];

        let mrkc2 = new google.maps.LatLng(
          obj.obj?.latitude,
          obj.obj?.longitude
        );
        let mrk2 = new google.maps.Marker({
          position: mrkc2,
          // map: this.map,
          title: `
                          <span style="cursor:pointer" class="span_service_map"
                                data-service='${dataService.replace(
                                  /'/g,
                                  '&apos;'
                                )}'>
                            <img src="/assets/img/icon_service2.png"/>
                            ${obj.obj.address},
                            <b>${this.hs.translate(obj.gi.productName)} - ${
            obj.gi.licensePlate
          } ${this.getTypeChassisByType(obj.gi.vehicleType)},</b>
                          </span>
                        `,
          icon: '/assets/img/icon_service2.png',
        });
        obj.marker = mrk2;
        // mrk2.setMap(this.map);
      }

      if (obj.type == 'driver') {
        if (obj.gi) {
          var dataDriver = JSON.stringify(obj.gi);
          let mrkc3 = new google.maps.LatLng(
            obj.obj.Latitude,
            obj.obj.Longitude
          );
          let mrk3 = new google.maps.Marker({
            position: mrkc3,
            // map: this.map,
            // title:this.getInitial(obj.gi.fullName)+' '+obj.gi.fullName,
            title:
              this.getInitial(obj.gi.fullName) +
              `
                              <span style="cursor:pointer" class="span_driver_map"
                                    data-driver='${dataDriver.replace(
                                      /'/g,
                                      '&apos;'
                                    )}'>
                                ${obj.gi.fullName}
                              </span>
                            `,
            icon: {
              url:
                'data:image/svg+xml;charset=UTF-8,' +
                encodeURIComponent(this.getInitial(obj.gi.fullName)),
              scaledSize: new google.maps.Size(30, 30),
            },
          });

          mrk3.addListener('click', () => {
            this.onDriverMarkerClick(obj.gi, obj.obj); // Llamar a tu función pasando los datos del conductor
          });

          obj.marker = mrk3;
          mrk3.addListener('mouseover', () => {
            // Guardar el title
            const originalTitleDriver = mrk3.getTitle();
            this.mt = originalTitleDriver;

            var spdriver = mrk3.getTitle();
            const regex = /data-driver='(.*?)'/;

            // Ejecutar la expresión regular en el texto
            const matchdriver = regex.exec(spdriver!);

            if (matchdriver && matchdriver[1]) {
              const dataDriverJson = JSON.parse(matchdriver[1]);
              mrk3.setTitle(dataDriverJson.fullName);
            } else {
              mrk3.setTitle('Titulo');
            }
          });

          // Evento para cerrar el InfoWindow
          mrk3.addListener('mouseout', () => {
            mrk3.setTitle(this.mt);
          });
          mrk3.setMap(this.map);
          this.drivers_markers.push(mrk3);
        }
      }
    });

    const map = this.map;
    const markers = this.PointsMarkers.filter(
      (item: any) => item.type != 'driver'
    ).map((position: any, i: any) => {
      const marker = position.marker;
      marker.addListener('mouseover', () => {
        // Guardar el title
        const originalTitle = marker.getTitle();
        this.mt = originalTitle;

        var sp = marker.getTitle();
        const regex = /data-service='(.*?)'/;

        // Ejecutar la expresión regular en el texto
        const match = regex.exec(sp);

        if (match && match[1]) {
          const dataServiceJson = JSON.parse(match[1]);
          if (position.type == 'pickup') {
            marker.setTitle(dataServiceJson.startUbication?.address);
          } else {
            marker.setTitle(dataServiceJson.endUbication?.address);
          }
        } else {
          marker.setTitle('Titulo');
        }
      });

      // Evento para cerrar el InfoWindow
      marker.addListener('mouseout', () => {
        marker.setTitle(this.mt);
      });
      return marker;
    });

    const markerCluster2 = new MarkerClusterer(map, markers, {
      styles: [
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-1',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-2',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-3',
        },
      ],
      clusterClass: 'custom-clustericon',
      zoomOnClick: false,
    });
    this.markerCluster = markerCluster2;
    const infoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, 0),
    });

    google.maps.event.addListener(markerCluster2, 'click', (cluster) => {
      const markers = cluster.getMarkers();
      let content =
        '\
                <table class="table table-bordered" style="width:700px">\
                    <thead>\
                    </thead>\
                    <tbody>';
      markers.forEach((marker: any) => {
        if (marker.getTitle() != '') {
          content += `<tr><td>${marker.getTitle()}</td><tr>`;
        }
      });
      content += '</tbody></table>';

      infoWindow.setContent(content);
      infoWindow.setPosition(cluster.getCenter());
      infoWindow.open(map);

      setTimeout(() => {
        var elementos = document.querySelectorAll('.span_service_map');
        elementos.forEach((elemento: any) => {
          elemento.addEventListener('click', (event: any) => {
            var dataService = elemento.getAttribute('data-service');
            try {
              var parsedData = JSON.parse(dataService);
              if (parsedData.driverId === '') {
                this.setActiveService(parsedData, undefined);
                infoWindow.close();
              } else {
                let driver = this.filtered_drivers.find(
                  (driver: any) => driver.driverId === parsedData.driverId
                );
                if (driver) {
                  this.setActiveService(parsedData, driver.driverId);
                  infoWindow.close();
                }
              }
            } catch (error) {
              console.error('Error al parsear data-service:', error);
            }
          });
        });

        var elementosdrivers = document.querySelectorAll('.span_driver_map');
        elementosdrivers.forEach((elemento: any) => {
          elemento.addEventListener('click', (event: any) => {
            var dataService = elemento.getAttribute('data-driver');
            try {
              var parsedData = JSON.parse(dataService);

          
            } catch (error) {
              console.error('Error al parsear data-driver:', error);
            }
          });
        });
      }, 500);
    });
  }

  onDriverMarkerClick(driverGi: any, driverLocation: any): void {
    if (!this.show_left_div) {
      this.backToMap();
    }
    this.changeSelectedItemFilter('drivers');
    this.filterData(driverGi.fullName);
    this.filterForm.get('mapfilter')?.setValue(driverGi.fullName);
    // this.alerts
    //   .open(`Has clickeado en ${driverGi.fullName}`, {
    //     label: 'Conductor seleccionado',
    //     status: 'info',
    //     autoClose: true,
    //   })
    //   .subscribe();

    this.map.setCenter(
      new google.maps.LatLng(
        driverLocation?.Latitude,
        driverLocation?.Longitude
      )
    );
    this.map.setZoom(15);
  }

  hideLeftDiv() {
    this.expandDivLeft = false;
    this.leftDivStyles.x = 155;
  }

  backToMap() {
    this.filterDriverServiceForm.get('driverservicefilter')?.setValue('');
    this.show_left_div = true;
    this.active_detail_service = null;
    this.drivers_for_service = [];
    this.selectedItemFilter = 'services';

    if (this.selectedItemFilter == 'services') {
      this.ngZone.run(() => {
        if (this.directionsRenderer) {
          this.directionsRenderer.setDirections({ routes: [] });
          this.directionsRenderer.setMap(null);
        }

        this.directionsRenderers.forEach((renderer) => {
          renderer.setMap(null);
        });
        this.directionsRenderers = [];

        this.customMarkers.forEach((marker) => {
          marker.setMap(null);
        });
        this.customMarkers = [];
        this.clearMarkers();
        this.drawMapPoints();
      });
    }
  }

  clients_list: any = [];
  client_info: any;
  correct_hour: any;
  elements_drivers_services: any = [];

  setServiceDate(date: string): string {
    return this.mapaDataUnifier.formatServiceDate(date);
  }

  getServiceDateOnly(date: string): string {
    return this.mapaDataUnifier.formatServiceDateOnly(
      date,
      this.translate.currentLang
    );
  }

  getServiceHour(date: string): string {
    return this.mapaDataUnifier.formatServiceHour(date);
  }

  async setActiveService(service: OrderData, driverId: string | undefined) {
    let driver = this.filtered_drivers.find(
      (driver: any) => driver.driverId === driverId
    );

    if (!driver && driverId) {
      this.showLoader();
      const driverObj: DriverDetailsResponse | undefined = await this.ms
        .getDriver(driverId!)
        .toPromise();
      if (driverObj && driverObj.drivers && driverObj.drivers[0]) {
        driver = driverObj?.drivers[0];
        this.elements_drivers.push(driver);
      }
      this.hideLoader();
    }

    this.resetFilteredData();
    this.clearMarkers();
    this.PointsMarkers = [];
    let data = {
      orderHash: service.orderHash,
      filterType: 'PROXIMITY',
    };
    // this.show_loader = !this.show_loader;
    this.ngZone.run(() => {
      this.active_detail_service = service;
      this.active_detail_service.serviceDate = this.setServiceDate(
        this.active_detail_service.serviceDate
      );

      if (driver) {
        this.active_desasign_driver = driver;
      } else {
        this.active_desasign_driver = undefined;
      }
      this.show_left_div = false;
      this.type_driver_start = 'service';
    });
    this.showLoader();
    await this.drawRoutes(service);

    this.hideLoader();

    if (driver?.lastLocation) {
      let data = {
        type: 'driver',
        obj: driver.lastLocation,
        gi: driver,
      };
      this.PointsMarkers.push(data);

      this.drawMapPoints();

      // this.centerMapOnLocation(
      //   driver.lastLocation.Latitude,
      //   driver.lastLocation.Longitude,
      //   driver.fullName,
      //   driver,
      //   true
      // );
    }
    this.cleanDriverServices();
  }

  addCustomMarkers(response: any): void {
    const route = response.routes[0];
    const legs = route.legs;

    for (let i = 0; i < legs.length; i++) {
      const leg = legs[i];

      if (leg.via_waypoints && leg.via_waypoints.length > 0) {
        leg.via_waypoints.forEach((waypoint: any, index: any) => {
          let cc = new google.maps.Marker({
            position: waypoint, // Cada via_waypoint
            map: this.map,
            icon: {
              url: 'assets/img/icon_service3.png', // Ruta a tu ícono personalizado
              scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
            },
            title: '',
          });

          this.customMarkers.push(cc);
        });
      }
      if (i === 0) {
        if (this.type_driver_start == 'service') {
          let pi = new google.maps.Marker({
            position: leg.start_location, // Punto de inicio del primer leg
            map: this.map,
            icon: {
              url: 'assets/img/icon_service.png', // Ruta a tu ícono personalizado
              scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
            },
            title: leg.start_address,
          });
          this.customMarkers.push(pi);
        } else {
          let pi = new google.maps.Marker({
            position: leg.start_location, // Punto de inicio del primer leg
            map: this.map,
            icon: {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
                this.icon_driver_start
              )}`,
              scaledSize: new google.maps.Size(30, 30),
            },
            title: '',
          });
          this.customMarkers.push(pi);
        }
      }

      // Marcar el punto final del leg
      if (i === legs.length - 1) {
        let pf = new google.maps.Marker({
          position: leg.end_location, // Punto final del último leg
          map: this.map,
          icon: {
            url: 'assets/img/icon_service2.png', // Ruta a tu ícono personalizado
            scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
          },
          title: leg.end_address,
        });
        this.customMarkers.push(pf);
      } else {
        let pw = new google.maps.Marker({
          position: leg.end_location,
          map: this.map,
          icon: {
            url: 'assets/img/icon_service3.png', // Ruta a tu ícono personalizado
            scaledSize: new google.maps.Size(30, 30), // Ajusta el tamaño del icono
          },
          title: leg.end_address,
        });
        this.customMarkers.push(pw);
      }
    }

    let cmarkers = this.customMarkers;
    let map = this.map;
    const markerClusterNew = new MarkerClusterer(map, cmarkers, {
      styles: [
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-1',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-2',
        },
        {
          width: 30,
          height: 30,
          className: 'custom-clustericon-3',
        },
      ],
      clusterClass: 'custom-clustericon',
      zoomOnClick: false,
    });
    this.markerCluster = markerClusterNew;
    let infoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, 0),
    });

    google.maps.event.addListener(markerClusterNew, 'click', (cluster) => {
      const markers = cluster.getMarkers();
      let content =
        '\
                <table class="table table-bordered" style="width:700px">\
                    <thead>\
                    </thead>\
                    <tbody>';
      markers.forEach((marker: any) => {
        let icon = marker.getIcon();
        if (marker.getTitle() != '') {
          content += `<tr><td><img src="${
            icon.url
          }" width="30" /> ${marker.getTitle()}</td><tr>`;
        }
      });
      content += '</tbody></table>';

      infoWindow.setContent(content);
      infoWindow.setPosition(cluster.getCenter());
      infoWindow.open(map);
    });
  }

  showLeftDiv() {
    this.expandDivLeft = true;
    this.leftDivStyles.x = 440;
  }

  changeSelectedItemFilter(item: any) {
    this.resetFilteredData();
    this.selectedItemFilter = item;
  }

  zoomInMap() {
    this.zoom_level = Number(this.zoom_level) + Number('1');
    this.map.setZoom(this.zoom_level);
  }

  zoomOutMap() {
    if (this.zoom_level >= 6) {
      this.zoom_level = Number(this.zoom_level) - Number('1');
      this.map.setZoom(this.zoom_level);
    }
  }

  clearMarkers(): void {
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
      this.markerCluster = null;
    }
    for (let marker of this.PointsMarkers) {
      marker?.marker?.setMap(null); // Borra el marcador del mapa
    }
    for (let markerd of this.drivers_markers) {
      markerd.setMap(null);
    }
  }
}
